export default __webpack_public_path__ + "static/media/language.a55c9c53.svg";